'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.series = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var series = exports.series = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    color: _propTypes2.default.string,
    opacity: _propTypes2.default.number,
    style: _propTypes2.default.object,
    data: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.shape({
        x: _propTypes2.default.number,
        y: _propTypes2.default.number,
        color: _propTypes2.default.string,
        opacity: _propTypes2.default.number,
        style: _propTypes2.default.object
    })]))
}));

exports.default = {
    series: series
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/helpers/propTypes.js
// module id = 101
// module chunks = 0